import { render, staticRenderFns } from "./addLicence.vue?vue&type=template&id=97977d84&scoped=true"
import script from "./addLicence.vue?vue&type=script&lang=js"
export * from "./addLicence.vue?vue&type=script&lang=js"
import style0 from "./addLicence.vue?vue&type=style&index=0&id=97977d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97977d84",
  null
  
)

export default component.exports